export const organisations: TableModule = {
    name: "organisations",
    route: "spa.system.organisations",
    columns: [
        {
            name: "id",
            sortable: true,
            width: "w-[100px]"
        },
        {
            name: "name",
            pageLink: true,
            sortable: true,
            sortBy: "name",
            mobile: true
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "plan",
            feature: "billingSystem"
        },
        {
            name: "active",
            sortable: true
        }
    ],
    filters: [
        {
            name: "id",
            column: "organisations.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "organisations.name",
            type: "string"
        },
        {
            name: "active",
            column: "organisations.active",
            type: "boolean"
        },
        {
            name: "email",
            column: "organisations.email",
            type: "string"
        }
    ],
    quickFilters: [
        {
            name: "customFilterMyCustomers",
            column: "customFilterMyCustomers",
            operator: "=",
            value: true,
            default: true
        },
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "organisations"]
        },
        {
            name: "organisations.toggle",
            color: "rose"
        },
        {
            name: "general.export"
        }
    ]
}
